/* ---------------------------------
GLOBAL FUNCTIONS
---------------------------------*/

// Add this new function
function calculateIVA(ivaElement, quantity, subtotalAmount) {
    if (!ivaElement || !ivaElement.innerText) {
        console.error('IVA element is missing or empty');
        return 0;
    }

    try {
        // Parse IVA value using the same logic as prices
        const baseIVA = getPriceFromString(ivaElement.innerText, "default");
        
        if (isNaN(baseIVA)) {
            console.error('Invalid IVA value:', ivaElement.innerText);
            return 0;
        }

        // Calculate total IVA
        const totalIVA = baseIVA * quantity;
        return totalIVA;

    } catch (error) {
        console.error('Error calculating IVA:', error);
        return 0;
    }
}

// Then modify the updateSubtotal method to use it:

//Con esta función pasamos $6.500,12 a 650012. Valores de precio y de IVA.
function getPriceFromString(value, type = "default") {
  // Si el tipo es IVA, solo elimina los separadores de miles y la coma decimal
  if (type === "IVA") {
    // Remove currency symbol and thousand separators, replace decimal comma with dot
    let cleanValue = value.replace(/\$/g, '')  // Remove $ symbol
                          .replace(/\./g, '')   // Remove thousand separators
                          .trim();              // Remove any whitespace    
    return parseFloat(cleanValue);
  }

  // Eliminar el símbolo de moneda y los puntos usados como separador de miles
  let cleanValue = value.replace(/[^\d,]/g, "").replace(/\./g, "");

  // Reemplazar la coma decimal por un punto para usar como separador decimal
  cleanValue = cleanValue.replace(",", ".");

  // Convertir a número
  return parseFloat(cleanValue);
}

//Con esta función pasamos 650012 a $6.500,12. Valores de precio y de IVA.
function getPriceFromNumber(value, type = "default") {
  // Redondear hacia abajo para obtener un número entero
  let roundedValue = Math.floor(value).toString();

  let formattedValue = roundedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // Si el tipo es default, añadir el símbolo de $
  return type === "default" ? `$${formattedValue}` : formattedValue;
}

//Redondea los primeros 2 decimales de un número
function roundToTwoDecimals(num) {
  return Math.round(num * 100) / 100;
}

//Mostramos el mensaje de error en la página de producto
showErrorMessage = () => {
  const errorSpan = document.querySelector("#error-adding-product");
  if (errorSpan.classList.contains("hidden")) {
    errorSpan.classList.remove("hidden");
  }
};

//Escondemos el mensaje de error en la página de producto
hideErrorMessage = () => {
  const errorSpan = document.querySelector("#error-adding-product");
  if (!errorSpan.classList.contains("hidden")) {
    errorSpan.classList.add("hidden");
  }
};

//Hace fetch al carrito
createCartPromise = () =>
  new Promise(async (t) => {
    t(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
  });

/* ---------------------------------
VARIANT SELECTOR
---------------------------------*/

class VariantSelector extends HTMLElement {
  constructor() {
    super();

    /* variants son los colores posibles. currentVariant es la variant inicial, la cual está en el
      atributo initial-variant*/
    this.variants = this.querySelectorAll(".variant");
    this.currentVariant = this.getAttribute("initial-variant");
    this.mainInput = this.querySelector("input");

    //Seleccionamos el slider y el quantity selector
    this.slider = document.querySelector(`#${this.dataset.id}`);
    this.qtySelector = document.querySelector(
      `#qty-selector-${this.dataset.id}`
    );
    this.sbtButton = document.querySelector(`#sbt-form-${this.dataset.id}`);

    /* Seleccionamos los tags que contienen el precio y unidades para modificarlos cuando se cambie de variante-
      También seleccionamos las imagenes del slider */
    this.priceTag = document.querySelector(`#price-${this.dataset.id}`);
    this.qtyTag = document.querySelector(`#qty-${this.dataset.id}`);
    this.iva = document.querySelector(`#iva-${this.dataset.id}`);
    this.images = document.querySelectorAll(`.slide-${this.dataset.id}`);
    this.vendorTags = document.querySelector("#vendorTag");
    this.mobileVendor = document.querySelector("#mobileVendorTag");


    //Adjuntamos el this a las funciones
    this.toggleVariant = this.toggleVariant.bind(this);
    this.handleUrlChange = this.handleUrlChange.bind(this);

    //Seleccionamos la variante por defecto y agregamos el evento de cambiar de variante
    this.variants.forEach((variant) => {
      if (variant.dataset.variantId === this.currentVariant) {
        variant.classList.add("selected-variant-card");
      }
      variant.addEventListener("click", () => this.toggleVariant(variant));
    });

    //Cada vez que se entre a una ruta de producto, se ejecuta esta función
    document.addEventListener("DOMContentLoaded", this.handleUrlChange);
  }

  //Cambiar de variante
  toggleVariant(variant) {
    //id de la variante seleccionada
    const selectedVariantId = variant.dataset.variantId;

    //Solo seguimos si esta variante NO esta seleccionada ya
    if (this.currentVariant !== selectedVariantId) {
      //Con esto cambiamos el estilo del boton seleccionado (el borde)
      this.variants.forEach((variant) => {
        if (variant.classList.contains("selected-variant-card")) {
          variant.classList.remove("selected-variant-card");
        }
      });

      variant.classList.add("selected-variant-card");

      //En el URL reflejamos la variante seleccionada
      window.history.replaceState({}, "", `?variant=${selectedVariantId}`);

      //Actualizamos cuál es la variante seleccionada
      this.currentVariant = selectedVariantId;

      //Cada vez que cambiamos la variante se actualizan los valores
      this.handleUrlChange();
      // **Actualizar el valor del input name_var con el nombre de la variante seleccionada**
      const nameVarInput = document.querySelector('input[name="name_var"]');
      if (nameVarInput) {
        const variantName = variant.dataset.color || variant.getAttribute("title"); // Extraer el nombre de la variante
        if (variantName) {
          nameVarInput.value = variantName; // Asignar el nombre de la variante al input
        } else {
          console.error("variantName está undefined");
        }
      } else {
        console.error('No se encontró el input con name="name_var"');
      }
    }
  }

  /* Con esta función modificamos el tag de precio y cantidad en base a la variante. Para eso usamos el
      parámetro que esta en el URL. */
      handleUrlChange() {
        //Seleccionamos la variante en base al URL. Si no hay, por defecto se toma la primera
        const params = new URLSearchParams(window.location.search);
        let variantId = params.get("variant");
        if (!variantId) {
            variantId = this.currentVariant;
        }
    
        // Mostramos las imágenes de esa variante y ocultamos las que no
        const thereAreImagesForVariant = Array.from(this.images).some(
            (img) => img.dataset.variantId === variantId
        );
    
        if (!thereAreImagesForVariant) {
            this.images.forEach((img) => {
                img.style.display = "flex";
            });
        } else {
            this.images.forEach((img) => {
                if (
                    variantId === img.dataset.variantId ||
                    img.dataset.variantId === "no-image"
                ) {
                    img.style.display = "flex";
                } else {
                    img.style.display = "none";
                }
            });
        }
    
        // Asignamos el id a un input que se enviará al form bajo id="id"
        this.mainInput.value = variantId;
    
        // Encontramos la variante actual
        const currentVariant = Array.from(this.variants).find(
            (variant) => variant.dataset.variantId === variantId
        );
    
        const minimumValue = document
            .querySelector("quantity-input")
            .getAttribute("minimum-value");
    
        if (
            Number(currentVariant.dataset.qty) === 0 ||
            Number(currentVariant.dataset.qty) < Number(minimumValue)
        ) {
            this.sbtButton.disabled = true;
            this.sbtButton.innerText = "Agotado";
        } else {
            this.sbtButton.disabled = false;
            this.sbtButton.innerText = "Agregar a cotización";
        }
    
        // Cambiamos el tag del precio, del IVA, el de cantidad y su propiedad value.
        const formattedPrice = getPriceFromString(currentVariant.dataset.price);
        const formattedCompareAtPrice = getPriceFromString(currentVariant.dataset.comparePrice);
    
        this.priceTag.innerText = getPriceFromNumber(formattedPrice);
        this.qtyTag.innerText = `${currentVariant.dataset.qty} unds`;
        this.qtyTag.dataset.value = currentVariant.dataset.qty;
    
        if (this.vendorTags) {
            this.vendorTags.innerText = `${currentVariant.dataset.sku}`;
        }
        if (this.mobileVendor) {
            this.mobileVendor.innerText = `${this.handleize(currentVariant.dataset.color) + "-" + currentVariant.dataset.sku}`;
        }
    
        this.slider.setAttribute("variant", variantId);
        //Asignamos cual será la cantidad máxima. Esto se hace para el product-form.
        this.qtySelector.setAttribute("maximum-value", currentVariant.dataset.qty);
        hideErrorMessage();
    
        // Mostrar u ocultar el precio a comparar
        const comparePriceTag = document.querySelector(`#compare-at-price-${this.dataset.id}`);
        if (comparePriceTag) {
            if (formattedPrice === formattedCompareAtPrice || isNaN(formattedCompareAtPrice)) {
                comparePriceTag.style.display = "none";
            } else {
                comparePriceTag.style.display = "inline";
            }
        }
    
        // Mostrar u ocultar el porcentaje de descuento
        const discountTag = document.querySelector(`#discount-${this.dataset.id}`);
        if (discountTag) {
            if (formattedPrice !== formattedCompareAtPrice && !isNaN(formattedCompareAtPrice)) {
                const discountPercentage = ((formattedCompareAtPrice - formattedPrice) / formattedCompareAtPrice) * 100;
                discountTag.innerText = `${Math.round(discountPercentage)}% OFF`;
                discountTag.style.display = "inline";
            } else {
                discountTag.style.display = "none";
            }
        }
    }    

  handleize(string) {
    return string
    .toLowerCase()
    .replace(" ", "-")
  }
}

customElements.define("variant-selector", VariantSelector);

/* ---------------------------------
QUANTITY INPUT
---------------------------------*/

class QtyInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.minusBtn = this.querySelector(`#minus-${this.dataset.id}`);
    this.plusBtn = this.querySelector(`#plus-${this.dataset.id}`);
    this.minimumValue = Number(this.getAttribute("minimum-value"));
    this.subtotal = document.querySelector(`#subtotal-tag`);
    this.iva = document.querySelector(`#iva-${this.dataset.id}`);
    this.totalIva = document.querySelector(`#total-iva-tag`);

    this.changeInOneQty = this.changeInOneQty.bind(this);
    this.changeWholeQty = this.changeWholeQty.bind(this);
    this.updateSubtotal = this.updateSubtotal.bind(this);

    this.minusBtn.addEventListener("click", () =>
      this.changeInOneQty(this.minusBtn.id)
    );
    this.plusBtn.addEventListener("click", () =>
      this.changeInOneQty(this.plusBtn.id)
    );
    this.input.addEventListener("change", this.changeWholeQty);
  }

  updateSubtotal() {
    let priceTag = document.querySelector(`#price-${this.dataset.id}`);
    let numberPrice = getPriceFromString(priceTag.innerText);

    this.subtotal.innerText = getPriceFromNumber(
      numberPrice * this.input.value
    );

    // Calculate and update IVA using the new function
    const totalIVA = calculateIVA(this.iva, this.input.value);
    if (this.totalIva) {
        this.totalIva.innerText = getPriceFromNumber(totalIVA);
    }
  }

  changeInOneQty(id) {
    const currentValue = Number(this.input.value);
    const maximumValue = Number(this.getAttribute("maximum-value"));
    if (id === `minus-${this.dataset.id}`) {
      if (currentValue > this.minimumValue) {
        this.input.value = currentValue - 1;
      }
    } else {
      if (currentValue < maximumValue) {
        this.input.value = currentValue + 1;
      }
    }
    this.updateSubtotal();
  }

  changeWholeQty() {
    const currentValue = Number(this.input.value);
    const maximumValue = Number(this.getAttribute("maximum-value"));
    //Verifica que no se escriba un numero mayor, menor o decimal.
    if (currentValue % 1 !== 0) {
      this.input.value = Math.floor(currentValue);
    }
    if (currentValue < this.minimumValue) {
      this.input.value = this.minimumValue;
    }
    if (currentValue > maximumValue) {
      this.input.value = maximumValue;
    }
    this.updateSubtotal();
  }

  static get observedAttributes() {
    return ["maximum-value"];
  }

  attributeChangedCallback(name) {
    if (name === "maximum-value") {
      this.input.value = this.minimumValue;
      this.updateSubtotal();
    }
  }
}

customElements.define("quantity-input", QtyInput);

/* ---------------------------------
LOGO PICKER
---------------------------------*/

class LogoPicker extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.submitIcon = this.querySelector("label");
    this.image = this.querySelector("img");
    this.wrongLogoIcon = this.querySelector(`#wrong-icon-${this.dataset.id}`);
    this.eraseLogoIcon = this.querySelector(`#erase-logo-${this.dataset.id}`);
    this.infoLogoSection = this.querySelector(`#info-logo-${this.dataset.id}`);
    this.selectedContainer = this.querySelector(
      `#container-selected-${this.dataset.id}`
    );
    this.fileNameElement = this.querySelector(`#file-name-${this.dataset.id}`);
    this.fileSizeElement = this.querySelector(`#file-size-${this.dataset.id}`);

    this.checkLogoSelected = this.checkLogoSelected.bind(this);
    this.deleteSelectedLogo = this.deleteSelectedLogo.bind(this);
    this.selectLogo = this.selectLogo.bind(this);

    this.input.addEventListener("change", this.checkLogoSelected);
    this.eraseLogoIcon.addEventListener("click", this.deleteSelectedLogo);
  }

  checkLogoSelected() {
    this.classList.remove("wrong-format");
    if (!this.wrongLogoIcon.classList.contains("hidden")) {
      this.wrongLogoIcon.classList.add("hidden");
    }

    const file = this.input.files[0];

    const allowedFormats = [
      "image/svg+xml", // SVG
      "image/png", // PNG
      "image/jpeg", // JPG, JPEG
      /* "application/pdf", // PDF */
      "application/postscript", // AI (Adobe Illustrator)
    ];
    if (allowedFormats.includes(file.type)) {
      this.selectLogo(file);
    } else {
      this.input.value = "";
      this.classList.add("wrong-format");
      this.wrongLogoIcon.classList.remove("hidden");
    }
  }

  deleteSelectedLogo() {
    this.input.value = "";
    this.submitIcon.classList.remove("hidden");
    this.eraseLogoIcon.classList.add("hidden");
    this.infoLogoSection.classList.remove("hidden");
    this.selectedContainer.classList.add("hidden");
  }

  async convertFileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        resolve(base64String); // Retorna el archivo en base64
      };
      reader.onerror = (error) => {
        reject(error); // Retorna el error si ocurre
      };

      reader.readAsDataURL(file); // Lee el archivo y lo convierte a base64
    });
  }

  async selectLogo(file) {
    try {
      const base64String = await this.convertFileToBase64(file);
      this.image.src = base64String;
      this.fileNameElement.innerText = file.name;
      this.fileSizeElement.innerText = `${(file.size / 1024).toFixed(2)} KB`;
      this.eraseLogoIcon.classList.remove("hidden");
      this.submitIcon.classList.add("hidden");
      this.infoLogoSection.classList.add("hidden");
      this.selectedContainer.classList.remove("hidden");
    } catch (error) {
      console.error("Error al convertir el archivo:", error);
    }
  }
}

customElements.define("logo-picker", LogoPicker);

/* ---------------------------------
PRODUCT FORM
---------------------------------*/

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.submitBtn = this.querySelector("button[type='submit']");
    this.submitBtn.addEventListener("click", (e) => this.submitForm(e));
    this.updateCartUi = this.updateCartUi.bind(this);
  }

  async submitForm(e) {
    //Prevenimos el comportamiento por defecto
    e.preventDefault();

    //Extraemos los form relacionados y los convertimos en JSON.
    const formData = new FormData(this.form);
    const formObj = Object.fromEntries(formData);
    //console.log(formObj);

    //Extraemos el file
    const fileUpload = formData.get("properties[imagenMarcado]");

    //Creamos un nuevo form donde se agregará el File
    const logoForm = new FormData();
    logoForm.append("file", fileUpload);

    //Sacamos de esta variante cual es la cantidad máxima que se puede agregar
    const maxQty = document.querySelector(`#qty-${formObj["section-id"]}`)
      .dataset.value;

    try {
      //Esto se hace solo si existe el archivo
      let imagenMarcado = "";

      if (fileUpload && fileUpload.size > 0) {
        //URL y token para el POST del logo

        const tempUrl =
          "https://marpico-integration-73b63855cda4.herokuapp.com/file/stage";
        const token =
          "Basic a21taTV6TWhPNTFJZk5CeTNVaWlnYW1FejZiUzJoSzRaWENwYnY3TzMwcVV5MXZnSHlyaVl0VWx1WThG";

        //Fetch del logo. Se envia el archivo File y se recibe un URL
        const resLogo = await fetch(tempUrl, {
          method: "POST",
          headers: {
            Authorization: token,
          },
          body: logoForm,
        });

        //Asignamos a imagenMarcado el url de la imagen
        const dataLogo = await resLogo.json();

        imagenMarcado = dataLogo?.url;

        //Se agrega el logo al formData
        formData.set("properties[imagenMarcado]", imagenMarcado);
      }
      //console.log(imagenMarcado);

      //Sacamos el carrito para verificar si el producto ya se agregó.
      const oldCart = await createCartPromise();

      //Buscamos en el carrito si este producto ya existe.
      const newVariantId = formData.get("id");

      //existingVariantInCart es un ARRAY con todos los productos que existan de esa variante
      const existingVariantsInCart = oldCart.items.filter((item) => {
        return String(item.variant_id) === String(newVariantId);
      });

      //marcadoType tendrá si se eligió marcado o no. En caso de que sí, tendrá el id de ese tipo.
      const marcadoType =
        formData.get("marcado") !== "0" ? formData.get(`rango-${formData.get("marcado")}`) : null;

      //console.log(existingVariantsInCart);
      //console.log("marcadoType: " + marcadoType);

      /* thisMarcadoExistsInVariant dirá si ya existe una variante con el marcado que se elija. 
      Esto también contempla si no se eligió un marcado y se agregó un producto sin marcado */
      const thisMarcadoExistsInVariant = existingVariantsInCart.find((item) => {
        //En caso de que no se haya elegido marcado, se buscará el que tengo belongMarcado vacío
        if (!marcadoType) {
          return !item.properties.marcadoConectado;
        }
        //En caso de que se haya elegido marcado, se buscará el que tenga el mismo tipo
        else {
          /* Acá buscamos en el carrito un item que pertenezca a la variante de interés (lo que implicaría que es un marcado
           anexado a la variante) y además que sea el mismo tipo de marcado */
          const temp = oldCart.items.find(
            (old) =>
              String(old.properties.varianteConectada) === String(item.id) &&
              marcadoType == String(old.id)
          );

          return temp?.properties?.itemConectado === item?.properties?.uid;
        }
      });
      //console.log(thisMarcadoExistsInVariant);

      /* 
      ----------
      FETCHS
      ----------
      */

      //CASO 1: NO existe la variante aún
      //CASO 2: YA existe la variante y el marcado ES DIFERENTE
      if (
        !existingVariantsInCart.length ||
        (existingVariantsInCart.length && !thisMarcadoExistsInVariant)
      ) {
        //Se esconde el mensaje de error cada vez que se agrega un producto
        hideErrorMessage();

        //Generamos un UID único para asignar a la variante que creemos. Este UID también se le asignará al marcado
        const relationUID = Math.random().toString(36).substring(2, 15);

        //Creamos el nuevo item
        const newVariantObject = {
          id: newVariantId,
          quantity: formData.get("quantity"),
          properties: {
            imagenMarcado,
            uid: relationUID,
            marcadoConectado:
              formData.get("marcado") !== "0" ? formData.get(`rango-name-${formData.get("marcado")}`) : null,
          },
        };
        //console.log(newVariantObject);

        //formattedData será el objeto que se pasará al fetch
        let formattedData = {};

        //Si hay fetch, agregamos el marcado antes y después el objeto. Esto para que aparezca después en el carrito.
        if (marcadoType) {
          formattedData = {
            items: [
              {
                id: formData.get(`rango-${formData.get("marcado")}`),
                quantity: formData.get(`rango-qty-${formData.get("marcado")}`) == "yes"  ? parseInt(formData.get("quantity")) :  1,
                properties: {
                  varianteConectada: formData.get("name_var"),
                  itemConectado: formData.get("name_prod"),
                  marcadoConectado: formData.get(`rango-name-${formData.get("marcado")}`),
                  uid: relationUID,
                },
              },
              newVariantObject,
            ],
          };
        } else {
          formattedData = {
            items: [newVariantObject],
          };
        }

        //Se hace el fetch del producto
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          body: JSON.stringify(formattedData),
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });

        if (response.ok) {
          this.updateCartUi();
        }
      }

      //CASO 3: YA existe la variante y el marcado ES IGUAL
      else {
        //console.log(thisMarcadoExistsInVariant);
        //console.log(oldCart);

        //line será la posición del item repetido. Con esto podemos identificar a esta versión en concreto
        const line =
          oldCart.items.findIndex(
            (item) =>
              item.properties.uid === thisMarcadoExistsInVariant.properties.uid
          ) + 1;
        //console.log(line);

        //totalQty será la nueva cantidad, sumando la que estaba previamente.
        const totalQty =
          thisMarcadoExistsInVariant.quantity + Number(formObj.quantity);

        //En caso de que exceda el inventario, mostramos el mensaje de error y salimos.
        if (totalQty > maxQty) {
          return showErrorMessage();
        }
        hideErrorMessage();

        const newObj = {
          line,
          quantity: totalQty,
        };

        //Si existe una imagen nueva, se actualiza el properties 
        if (imagenMarcado) {
          newObj.properties = {
            ...thisMarcadoExistsInVariant.properties,
            imagenMarcado,
          };
        }
        //console.log(newObj);

        await fetch(`${Shopify.routes.root}cart/change.js`, {
          body: JSON.stringify(newObj),
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });

        this.updateCartUi();
      }
    } catch (error) {
      console.error("Error al agregar producto al carrito:", error);
      return false
    }
    return false
  }

  // Se trae el cart nuevo y se pasa como parámetro en el evento cart:change.
  //Esto se hace para actualizar el UI del carrito.
  updateCartUi = async () => {
    const cart = await createCartPromise();
    //console.log(cart);

    //cart es el carrito actualizado, openCart dice si abrir el menú de carrito o no.
    this.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        cart,
        detail: {
          cart,
          openCart: true,
        },
      })
    );
  };
}

customElements.define("product-form", ProductForm);
